module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/application.a8e7d568.png";